<template>
  <div class="content-top">
    <img v-if="src" :src="src" :alt="title" :title="title"/>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    title: String,
  },
};
</script>

<style>
.content-top{
  width: 100%;
}
.content-top img{
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Pic.vue